import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixAssetsScriptsV1SiteScriptsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'bo._base_domain_': [
      {
        srcPath: '/_api/site-scripts',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/site-scripts',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/site-scripts',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/assets/scripts/v1/site-scripts',
        destPath: '/v1/site-scripts',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_headless-site-assets_scripts';

/** Retrieves a list of up to 100 site scripts */
export function listSiteScripts(payload: object): RequestOptionsFactory<any> {
  function __listSiteScripts({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.assets.v1.site_script',
      method: 'GET' as any,
      methodFqn: 'wix.assets.scripts.v1.SiteScriptsService.ListSiteScripts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixAssetsScriptsV1SiteScriptsServiceUrl({
        protoPath: '/v1/site-scripts',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listSiteScripts;
}

/** Retrieves the essential properties of the site */
export function getEssentialProperties(
  payload: object
): RequestOptionsFactory<any> {
  function __getEssentialProperties({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.assets.v1.site_script',
      method: 'GET' as any,
      methodFqn:
        'wix.assets.scripts.v1.SiteScriptsService.GetEssentialProperties',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixAssetsScriptsV1SiteScriptsServiceUrl({
        protoPath: '/v1/site-scripts/essentials',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getEssentialProperties;
}

/** Retrieves site metadata including both site scripts and essential properties */
export function getSiteMetadata(payload: object): RequestOptionsFactory<any> {
  function __getSiteMetadata({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.assets.v1.site_script',
      method: 'GET' as any,
      methodFqn: 'wix.assets.scripts.v1.SiteScriptsService.GetSiteMetadata',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixAssetsScriptsV1SiteScriptsServiceUrl({
        protoPath: '/v1/site-scripts/metadata',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getSiteMetadata;
}
